import { INBOX_BOOTSTRAP_SIZE } from "@/lib/constants/inbox";

const STORAGE_KEY = "mail_folder_bootstrap_v3";
const LEGACY_STORAGE_KEYS = ["mail_folder_bootstrap_v2", "mail_folder_bootstrap_v1"] as const;

let legacyBootstrapPurged = false;

function purgeLegacyBootstrapCaches(): void {
  if (legacyBootstrapPurged) return;
  legacyBootstrapPurged = true;
  try {
    for (const key of LEGACY_STORAGE_KEYS) {
      localStorage.removeItem(key);
    }
  } catch {
    /* ignore */
  }
}

type BootstrapEntry = {
  accountId: number;
  folder: string;
  size: number;
  at: number;
};

function readAll(): BootstrapEntry[] {
  purgeLegacyBootstrapCaches();
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as BootstrapEntry[];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeAll(entries: BootstrapEntry[]): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(entries.slice(0, 256)));
  } catch {
    /* quota */
  }
}

function entryKey(accountId: number, folder: string): string {
  return `${accountId}\0${folder}`;
}

/** Dossier déjà synchronisé (persiste entre sessions navigateur). */
export function isFolderBootstrapDone(
  accountId: number,
  folder: string,
  minSize = INBOX_BOOTSTRAP_SIZE
): boolean {
  const match = readAll().find(
    (e) => e.accountId === accountId && e.folder === folder
  );
  if (!match) return false;
  return match.size >= minSize;
}

export function markFolderBootstrapDone(
  accountId: number,
  folder: string,
  size = INBOX_BOOTSTRAP_SIZE
): void {
  const next: BootstrapEntry = {
    accountId,
    folder,
    size,
    at: Date.now(),
  };
  const rest = readAll().filter(
    (e) => entryKey(e.accountId, e.folder) !== entryKey(accountId, folder)
  );
  writeAll([next, ...rest]);
}

export function clearFolderBootstrapDone(accountId: number, folder: string): void {
  writeAll(
    readAll().filter(
      (e) => !(e.accountId === accountId && e.folder === folder)
    )
  );
}

export function clearAccountBootstrapDone(accountId: number): void {
  writeAll(readAll().filter((e) => e.accountId !== accountId));
}

export function clearAllFolderBootstrapDone(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
    for (const key of LEGACY_STORAGE_KEYS) {
      localStorage.removeItem(key);
    }
  } catch {
    /* ignore */
  }
}
